import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/payroll-templates',
    name: 'payroll-template',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/payroll-template/index.vue')
  }
]
